import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitlePositioner } from '@shared/general';
import { TextLabel } from '@lib/ui-components';
import { useCompanyBranchContext } from '../../../../../../../../../contexts/company-branch.context';
import { CompanyContactPersonsTable } from '../../../../company-contact-persons-table';
import {
  ContactPersonTypeEnum,
} from '../../../../../../../../../libs/api-interface/models/company/contact-person-type.enum';

export const CompanyBranchReports = () => {
  const { t } = useTranslation();
  const companyBranch = useCompanyBranchContext();

  return (
    <>
      <TitlePositioner>
        <TextLabel label={t('reportsSendingContacts')} />
      </TitlePositioner>
      <CompanyContactPersonsTable companyId={companyBranch.companyId!} branchId={companyBranch.branchId} type={ContactPersonTypeEnum.REPORT} />
    </>
  );
};
